import React, { useState, useRef, useCallback, useLayoutEffect, useEffect } from 'react';
import PropTypes from 'prop-types';
import errorBoundary from '@ifeng-fe/errorBoundary';
import Style from './index.css';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Mousewheel, Keyboard } from 'swiper';
import People from '@src/pc/index/layout/Page1/People';
import Chip from 'Chip';

const Page1 = (props) => {
    const [starAnimation, setStarAnimation] = useState(false);
    const [isLoadVideo, setIsLoadVideo] = useState(false);
    const videoRef = useRef(null);
    const logoRef = useRef(null);
    const videoUrl = 'https://x0.ifengimg.com/fe/custom/2023_11_13/e506f6c.mp4';
    const { peopleList, leaderVideo, onChangeMaskVisible, onChangeCurrentVideo, onChangeFloat, config, peopleIndex, onChangePeopleIndex, guestData } = props;
    const [isShowHUD, setIsShowHUD] = useState(false);

    const swiperRef = useRef();

    const changePeopleAndSwiper = (index) => {
        onChangePeopleIndex(index);
    };

    useLayoutEffect(() => {
        // eslint-disable-next-line no-unused-expressions
        swiperRef.current?.slideTo(peopleIndex + 1);
    }, [peopleIndex]);

    useEffect(() => {
        const videoElement = document.createElement('video');
        let videoPlayNum = 0;

        videoElement.src = videoUrl;

        if (videoElement.onloadedmetadata) {
            videoElement.addEventListener('loadedmetadata', () => {
                setIsLoadVideo(true);

                setTimeout(() => {
                    setIsShowHUD(true);
                    onChangeFloat(true);
                }, 3500);
            });
        } else {
            videoElement.addEventListener('loadstart', () => {
                setTimeout(() => {
                    setIsLoadVideo(true);

                    setTimeout(() => {
                        setIsShowHUD(true);
                        onChangeFloat(true);
                    }, 3500);
                }, 1000);
            });
        }

        const videoDom = videoRef.current;
        const logoDom = logoRef.current;

        logoDom.addEventListener('animationend', () => {
            videoDom.play();
            setStarAnimation(true);
        });
        videoDom.addEventListener('timeupdate', () => {
            if (videoDom.currentTime > 8) {
                videoPlayNum++;
                if (videoPlayNum === 1) {
                    changePeopleAndSwiper(0);
                }
            }
        });

        videoDom.addEventListener('ended', () => {
            videoDom.currentTime = 9;

            videoDom.play();
        });
    }, []);

    const toPrev = () => {
        changePeopleAndSwiper(peopleIndex - 1);
    };

    const toNext = () => {
        if (peopleIndex < peopleList.length - 1) {
            changePeopleAndSwiper(peopleIndex + 1);
        }
    };

    const openVideo = () => {
        onChangeCurrentVideo({
            url: leaderVideo.videoUrl,
            guid: leaderVideo.videoGuid,
            duration: leaderVideo.videoDuration,
        });
        onChangeMaskVisible(true);
    };

    return (
        <div className={Style.page1}>
            {peopleIndex === -1 && <img className={`${Style.logo} ${isShowHUD ? Style.show : ''}`} src={require('@src/common/assets/logo.png')} alt="" />}
            {config.find((a) => a.id === 'peopleList').isShow && (
                <div className={`${Style.peopleList} ${isShowHUD ? Style.show : ''} ${peopleIndex < 0 ? '' : Style.inPeople}`}>
                    <div className={Style.first}>
                        <div className={`${Style.people} ${-1 === peopleIndex ? Style.active : ''}`} onClick={() => changePeopleAndSwiper(-1)}>
                            首页
                        </div>
                        <span className={Style.divider}>/</span>
                    </div>
                    {peopleList.map((people, index) => {
                        return (
                            <div key={index}>
                                <div className={`${Style.people} ${index === peopleIndex ? Style.active : ''}`} onClick={() => changePeopleAndSwiper(index)}>
                                    {people.name}
                                </div>
                                {index < peopleList.length - 1 && <span className={Style.divider}>/</span>}
                            </div>
                        );
                    })}
                </div>
            )}
            <Swiper
                modules={[Navigation, Mousewheel, Keyboard]}
                className={Style.swiper}
                speed={1500}
                mousewheel={{
                    forceToAxis: true,
                }}
                keyboard={{
                    enabled: true,
                }}
                onSwiper={(swiper) => (swiperRef.current = swiper)}
                onSlideChange={(swiper) => onChangePeopleIndex(swiper.realIndex - 1)}>
                <SwiperSlide>
                    <div style={{ position: 'relative', height: '100%' }}>
                        <div className={`${Style.bannerBox} ${isLoadVideo ? Style.bannerShow : ''}`} ref={logoRef}>
                            <img className={`${Style.bannerPic}`} src="https://x0.ifengimg.com/ucms/2023_44/3FD823B3D4B564DAEB7F585811418F7DEE543CCC_size19_w179_h182.png" />
                            <img
                                className={`${Style.bannerStarBottom}  ${starAnimation ? Style.opacityAnimi : ''}`}
                                src="https://x0.ifengimg.com/ucms/2023_45/FB5985F1F6A3CE479845D89E33E40B0FDCB12771_size13_w364_h132.png"
                            />
                            {/* <img className={`${Style.bannerStar} ${starAnimation ? Style.bannerShow : ''}`} src="https://x2.ifengimg.com/fe/custom/junpintan2022/light.030aecac.png" /> */}
                            <img
                                className={`${Style.bannerStar}  ${starAnimation ? Style.opacityAnimi : ''}`}
                                src="https://x0.ifengimg.com/ucms/2023_46/993D85E55A10B1E82D87BE6F18425885BCB02235_size12_w223_h224.png"
                            />
                        </div>
                        <video muted={true} className={Style.bannerVideo} controls={false} preload="auto" ref={videoRef} src={videoUrl} />
                        <Chip id="260747" type="struct" name="leaderVideo" title="先导片" groupName="先导片">
                            <div className={`${Style.playWp} ${isShowHUD ? Style.show : ''}`} onClick={openVideo}>
                                {leaderVideo?.videoUrl && (
                                    <div className={Style.play}>
                                        <img className={Style.play} src="https://x0.ifengimg.com/ucms/2023_46/EEFE9F410651269252106F82B6A95F62EFC9831C_size3_w59_h59.png" alt="" />
                                        <span>先导片</span>
                                    </div>
                                )}
                            </div>
                        </Chip>
                    </div>
                </SwiperSlide>
                {config.find((a) => a.id === 'peopleList').isShow &&
                    peopleList.map((people, index) => {
                        return (
                            <SwiperSlide key={index}>
                                <People people={people} guestData={guestData} onChangeMaskVisible={onChangeMaskVisible} onChangeCurrentVideo={onChangeCurrentVideo} index={index} />
                            </SwiperSlide>
                        );
                    })}
            </Swiper>
            {config.find((a) => a.id === 'peopleList').isShow && isShowHUD && (
                <>
                    <img
                        className={`${Style.navigation} ${Style.prev} ${peopleIndex > -1 ? '' : Style.hide}`}
                        src={require(`@src/common/assets/${peopleIndex > -1 ? 'prev' : 'prev2'}.png`)}
                        alt=""
                        onClick={toPrev}
                    />
                    <img
                        className={`${Style.navigation} ${Style.next} ${peopleIndex === -1 ? Style.animate : ''}`}
                        src={require(`@src/common/assets/${peopleIndex > -1 ? 'next' : 'next2'}.png`)}
                        alt=""
                        onClick={toNext}
                    />
                </>
            )}
        </div>
    );
};

Page1.propTypes = {
    peopleList: PropTypes.array,
    config: PropTypes.array,
    leaderVideo: PropTypes.object,
    onChangeMaskVisible: PropTypes.func,
    onChangeCurrentVideo: PropTypes.func,
    onChangeFloat: PropTypes.func,
    peopleIndex: PropTypes.number,
    onChangePeopleIndex: PropTypes.func,
    guestData: PropTypes.array,
};

export default errorBoundary(Page1);
